import { uploadPrivateAsset } from '@ff-os/pdp-shared-redux/apis/private-assets/uploadPrivateAsset';
import { blobUrlStore } from '@ff-os/rendering-react/asset-loading/blobUrlStore';
import { isSupportedByBrowser } from '@ff-os/shared-react/dom/images/image-browser-support';
import { normalizeImage } from '@ff-os/shared-react/dom/images/normalize-image';
import { PrivateAssetUploadAction } from '@ff-os/shared-utils/types/private-assets/PrivateAssetUploadAction';
import { GiftPdpThunk } from '@ff-scene-plugins/gift-redux/store';
import { GiftUploadContext } from '@ff-scene-plugins/gift-shared/GiftUploadContext';
import cuid from 'cuid';
import { PhotoUploadData } from '../../private-assets/PhotoUploadData';

export const uploadImage = (image: File, variableId: string): GiftPdpThunk => {

    return async (dispatch) => {

        const request: PrivateAssetUploadAction<GiftUploadContext<PhotoUploadData>> = {
            upload: { type: 'Photo', file: image },
            context: {
                pluginId: 'photo',
                variableId: variableId,
                variableData: {
                    cuid: cuid(),
                    fileName: image.name,
                    processed: false
                }
            }
        };

        if (isSupportedByBrowser(image)) {

            const { url: localUrl, width, height } = await normalizeImage(image);

            const photoUploadWithFileMeta: PrivateAssetUploadAction<GiftUploadContext<PhotoUploadData>> = {
                ...request,
                context: {
                    ...request.context,
                    variableData: {
                        ...request.context.variableData,
                        processed: true,
                        localUrl: localUrl,
                        imageWidth: width,
                        imageHeight: height
                    }
                }
            };

            blobUrlStore.track(localUrl);
            await dispatch(uploadPrivateAsset(photoUploadWithFileMeta));
        } else {
            await dispatch(uploadPrivateAsset(request));
        }
    };
};